import SubscriberUtils from '../utils/subscriber-utils';


/**
 *
 */
const setupShowSubscriberIds = () =>
{
	const elems = document.querySelectorAll( '[data-show-subscriber-id]' );

	elems.forEach( elem =>
	{
		if (elem instanceof HTMLElement) {

			elem.innerHTML = `<p>Please contact us at <a href="mailto:advice@waterisawesome.com">advice@waterisawesome.com</a>.</p>`;

			SubscriberUtils.getSubscriberInfo().then( subscriber =>
			{
				elem.innerHTML = `<p>Your Subscriber ID is: <code>${subscriber.uid}</code></p>`;
			} );
		}
	} );
};


/**
 *
 */
export default setupShowSubscriberIds;